export const CatchAllErrorFallback = () => <div>Something went wrong...</div>;
